import { get } from 'svelte/store';
import { location } from 'svelte-spa-router';
import { setSidePanelState } from 'src/components/Sidepanel/sidepanel-helpers';
import { drawerRef, drawerState, sidePanelStateCombined } from 'src/stores/ui/sidepanel-public';

// Get initial drawer state
export const getDrawerState = () => {
	if (get(location).split('/')[2] === 'room')
		return { type: 'room', id: get(location).split('/')[3], open: false };
	return { type: 'dash', open: false };
};

// Set initial drawer state
const setDrawerState = () => {
	setSidePanelState(
		get(location).split('/')[2] === 'room'
			? { type: 'room', id: get(location).split('/')[3] }
			: { type: 'dash' },
	);
};

// Reset drawer state without action
export const resetDrawer = (action?: string) =>
	action === 'login' ? setSidePanelState({ type: 'dash' }) : setDrawerState();

// Reset drawer state then close it
export const resetDrawerClose = () => {
	setDrawerState();
	setSidePanelState({ open: false });
};

// Reset drawer state then open it
export const resetDrawerOpen = () => {
	setDrawerState();
	setSidePanelState({ open: true });
};

// For futher improvements of the drawer, more custom functions can always be made

// Toggle drawer state
//TODO check why to we need this logic at all?
//OLD implementation
// export const toggleDrawerState = () => {
// 	if (typeof get(drawerState).open !== 'undefined') {
// 		if (get(drawerState).open) {
// 			get(drawerRef).close();
// 			get(drawerRef).open();
// 		} else {
// 			get(drawerRef).open();
// 			get(drawerRef).close();
// 		}
// 	}
// };
export const toggleDrawerState = () => {
	const sidePanelState = get(sidePanelStateCombined);
	if (typeof sidePanelState.open !== 'undefined') {
		if (sidePanelState) {
			setSidePanelState({ open: false });
			setSidePanelState({ open: true });
		} else {
			setSidePanelState({ open: true });
			setSidePanelState({ open: false });
		}
	}
};

// Open specific drawer by providing type and id
export const openDrawer = (type: string, id?: string | number) => {
	drawerState.set({
		...get(drawerState),
		type: type,
		id: id as string,
	});
	get(drawerRef).open();
};
